import type { TreeMapContextData } from "./tree-map.type";

import { createContext, useContext } from "react";

export const config = {
  contextName: "TreeMapContext",
  providerName: "TreeMapProvider",
};

export const TreeMapContext = createContext<TreeMapContextData | null>(null);

export const useTreeMap = () => {
  const contextValue = useContext(TreeMapContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
